import { render, staticRenderFns } from "./InvestorFunnelPage.vue?vue&type=template&id=761bb7b5&"
import script from "./InvestorFunnelPage.vue?vue&type=script&lang=js&"
export * from "./InvestorFunnelPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports